export const moreThanZero = (_, value) => {
  if (value != null && value != undefined && (Number(value) <= 0)) {
    return Promise.reject(new Error('Amount must be greater than zero!'));
  }
  return Promise.resolve();
};
